<template>
  <div class="d-flex align-items-center gap-2 w-100">
    <div class="dropdown-container position-relative col">
      <div class="dropdown-input dropdown border-default bg-primary-white w-100 outline-none caption d-block align-items-center">
        <DatePickerV2 />
      </div>
      <div class="label" style="z-index: 1">{{ content.planner_prestationsDates }}</div>
    </div>
    
    <div class="dropdown-container position-relative col">
      <div class="dropdown-input dropdown bg-primary-white w-100 outline-none caption d-flex align-items-center">
        <Participants
          @changeOpenParticipants="handleChangeOpenParticipants"
          @setParticipants="handleSetParticipants"
          @notEnoughAdults="handleNotEnoughAdults"
        />
      </div>
      <div class="label" style="z-index: 1">{{ content.planner_prestationsParticipants }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
  // Store
  // import store from '@/vue/planning/store/store'
  import DatePickerV2 from '@/vue/planning/components/search/DatePickerV2.vue'
  import Participants from '@/vue/planning/components/search/participants.vue'
  import { computed } from 'vue'

  import { useStore } from 'vuex'
  const store = useStore()

  const content = computed(() => store.state.content)

  const handleChangeOpenParticipants = (bool: boolean) => {
    store.dispatch('setParticipantsDropdownOpen', bool)
  }

  const handleSetParticipants = (newArray: Array<unknown>) => {
    store.dispatch('setParticipants', newArray)
  }

  const handleNotEnoughAdults = () => {
    store.commit('setErrorMessageOpen', 'errorMessages_notEnoughAdults')
  }
</script>

<style scoped>
.dropdown-container {
  cursor: pointer;
}

.dropdown-input {
  border: 1px solid var(--grey-300);
  border-radius: var(--border-radius-card);
  height: 60px;
  padding: 0px;
  position: relative;
}

.dropdown-input.dropdown {
  padding: 0px;
  border-radius: var(--border-radius-card);
  border: 1px solid var(--grey-300);
}

.label {
  position: absolute;
  top: -8px;
  left: 16px;
  background: white;
  padding: 0 8px;
  font-size: 12px;
  color: black;
  font-weight: 500;
}

.date-picker-wrapper {
  position: relative;
  overflow: visible !important;
}
</style>
